"use client";

// src/card.tsx
import { cn } from "@momo/utils";
import { jsx } from "react/jsx-runtime";
var Card = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn("bg-card text-card-foreground rounded-lg border shadow-sm", className),
      ...rest
    }
  );
};
var CardHeader = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: cn("flex flex-col gap-1.5 p-6", className), ...rest });
};
var CardTitle = (props) => {
  const { className, ...rest } = props;
  return (
    // eslint-disable-next-line jsx-a11y/heading-has-content -- content is passed via children
    /* @__PURE__ */ jsx("h3", { className: cn("text-2xl font-semibold leading-none tracking-tight", className), ...rest })
  );
};
var CardDescription = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("p", { className: cn("text-muted-foreground text-sm", className), ...rest });
};
var CardContent = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: cn("px-6 pb-6", className), ...rest });
};
var CardFooter = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx("div", { className: cn("flex items-center px-6 pb-6", className), ...rest });
};

export {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter
};
